import React from 'react'
import { Modal, Group, Button, Text } from '@mantine/core'

interface Props {
  opened: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
  variant?: 'danger' | 'warning' | 'info';
}

export default function ConfirmModal ({
  opened,
  title,
  message,
  confirmLabel = 'Confirm',
  onConfirm,
  onClose,
  variant = 'info'
}: Props) {
  const confirmColor =
    variant === 'danger' ? 'red' : variant === 'warning' ? 'yellow' : 'blue'

  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <Modal opened={opened} onClose={onClose} title={title} radius="md" centered>
      <Text size="sm" color="dimmed" mb="md">
        {message}
      </Text>
      <Group position="right" spacing="xs">
        <Button variant="default" color="gray" onClick={onClose}>
          Cancel
        </Button>
        <Button color={confirmColor} onClick={handleConfirm}>
          {confirmLabel}
        </Button>
      </Group>
    </Modal>
  )
}
